import { render, staticRenderFns } from "./SubmissionJudgeView.vue?vue&type=template&id=18e572bf&"
import script from "./SubmissionJudgeView.vue?vue&type=script&lang=js&"
export * from "./SubmissionJudgeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports